export const DefaultPaginationSettings = {
  ROW_HEIGHT: 50,
  ROWS_PER_PAGE_FOR_SMALL_DATA: 5,
  ROWS_PER_PAGE_FOR_LARGE_DATA: 10,
  ROWS_PER_PAGE_OPTION_FOR_SMALL_DATA: [5, 10, 20, 50],
  ROWS_PER_PAGE_OPTION_FOR_LARGE_DATA: [10, 20, 50, 100],
};
